import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/icon-car-series-double-arrow.png'


const _withScopeId = n => (_pushScopeId("data-v-4dbd769d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "close-icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    value: _ctx.value,
    position: _ctx.position,
    style: { left: '75px', height: '100%', overflow: 'visible', zIndex: 9999999999 }
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      _withDirectives(_createElementVNode("div", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePCPopupVisible(false)))
      }, _hoisted_2, 512), [
        [_vShow, _ctx.position === 'right']
      ])
    ]),
    _: 3
  }, 8, ["value", "position"]))
}